import React from 'react';
import { useEffect, useState } from 'react';
import { isMobileOnly } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import moment from 'moment';
import InfiniteScroll from 'react-infinite-scroll-component';
import Layout, { MainBody } from 'components/Layout';
import AppointmentCard from 'components/Appointment/components/Card';
import HeaderBar from 'components/Layout/HeaderNavBar';
import { getAppointments } from 'redux/reducer/appointment';
import { cleverTapAnl } from 'utilities';
import { Loader } from 'shared';
import { getTimeFromMinutes } from 'utils';

const enableStatus = new Set(['completed', 'cancelled', 'active', 'booked', 'noshow']);
const appointmentBatchCount = 20;
const Root = styled(Layout)`
  position: relative;

  ${AppointmentCard} {
    margin-bottom: 22px;
  }

  ${MainBody} { padding-top: 0; }

  ${() => isMobileOnly && css`
    ${MainBody} {
      padding-top: 16px;
    }
  `}
`;

const AppointmentList = ({
  history,
}: any) => {

  const { user } = useSelector(state => state.auth);
  const {
    appointments,
    hasMoreAppointment,
  } = useSelector(state => state.appointment);
  const [vcAppointmentList, setVcAppointmentList] = useState<any>([]);
  const [pageNo, setPageNo] = useState(0);
  const dispatch = useDispatch();

  function fetchAppointments() {
    if (!user.userID || !user.mobileNumber) return;

    setPageNo(pageNo + 1);
    dispatch(getAppointments({
      userID: user.userID, params: {
        mobileNumber: user.mobileNumber,
        offset: appointmentBatchCount,
        page: pageNo + 1,
        teleConsult: true,
        type: 'appointment',
      },
    }));
  }

  useEffect(() => {
    const vcAppointments: any = [];
    appointments.forEach((appointment: any) => {
      if (appointment.isTeleConsult && enableStatus.has(appointment.status)) {
        vcAppointments.push(appointment);
      }
    });

    setVcAppointmentList(vcAppointments);
  }, [appointments]);

  useEffect(() => {
    fetchAppointments();
  }, [user]);

  function handleBackIconClick() {
    history.push('/support/');
  }

  function triggerAppointmentSelectEvent(appointment) {
    cleverTapAnl.event({
      event_name: 'help_appointment_select',
      event: {
        page_name: 'help',
        appointment_status: appointment.status,
        appointment_id: appointment.appointmentID,
        teleconsult_id: appointment.teleConsultSessionObject?.id,
        doctor_id: appointment.doctorID,
        appointment_date: moment(appointment.appointmentDisplayTime).format('YYYY-MM-DD'),
        slot_type: appointment.isTeleConsult ? 'video' : 'physical',
        slot_time: getTimeFromMinutes(appointment.appointmentTime),
        transaction_amount: appointment.teleConsultSessionObject?.pricing_details.total,
      },
    });
  }

  function handleCardClick(appointment) {
    triggerAppointmentSelectEvent(appointment);
    history.push(`/support/appointment/${appointment.appointmentID}`);
  }

  return (
    <Root
      hideFooter={isMobileOnly}
      header={isMobileOnly ? <HeaderBar onBackIconClick={handleBackIconClick} /> : null}
    >
      <HeaderBar hidden={isMobileOnly} onBackIconClick={handleBackIconClick} />

      <InfiniteScroll
        loader={<Loader />}
        hasMore={hasMoreAppointment}
        dataLength={vcAppointmentList.length}
        scrollThreshold={0.85}
        scrollableTarget='mainBody'
        next={fetchAppointments}
      >
        {
          vcAppointmentList.map((appointment: any) => (
            <AppointmentCard
              key={`${appointment.appointmentID}-${appointment.patientID}`}
              appointment={appointment}
              onCardClick={handleCardClick}
            />
          ))
        }
      </InfiniteScroll>
    </Root>
  );
};

export default AppointmentList;